import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { usePrinterContext } from '../../../contexts/PrinterContext/hooks/usePrinterContext.hook';
import type { OnPrintHandler } from '../../../components/DocumentEditor/types/props.type';

import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly missionReportId: Id;
  readonly snackbarActionTarget: string;
}

export const usePrintHandler = ({
  missionReportId,
  snackbarActionTarget,
}: Readonly<Params>) => {
  const { queryKeyToInvalidate } = useQueryInvalidation(missionReportId);

  const { print } = usePrinterContext();

  const onPrint = useCallback<OnPrintHandler>(
    (params) => {
      print({
        ...params,
        printableId: missionReportId,
        snackbarActionTarget,
        command: 'printMissionReport',
        queryKeysToInvalidate: [queryKeyToInvalidate],
      });
    },
    [missionReportId, print, queryKeyToInvalidate, snackbarActionTarget],
  );

  return { onPrint };
};
